import { useStaticQuery, graphql } from "gatsby"

export const useBlogCategories = () => {
  const { allSanityBlogCategory } = useStaticQuery(graphql`
    query {
      allSanityBlogCategory {
        nodes {
          title
          slug {
            current
          }
          posts {
            _id
          }
        }
      }
    }
  `)
  return allSanityBlogCategory.nodes || []
}
